interface CreditTransferIconProps {
  className?: string
}

export const CreditTransferIcon = ({ className }: CreditTransferIconProps) => {
  return (
    <svg
      width="49"
      height="52"
      viewBox="0 0 49 52"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Aproveitamento de Estudos</title>
      <path
        d="M35.9765 4H20.0282H18.7929L17.9197 4.87319L5.84594 16.9471L4.97266 17.8202V19.0555V43.9473C4.97266 48.3874 8.58466 52.0001 13.0254 52.0001H35.9765C40.4165 52.0001 44.0285 48.3874 44.0285 43.9473V12.0527C44.0285 7.612 40.4165 4 35.9765 4ZM41.0469 43.9473C41.0469 46.7482 38.7768 49.0184 35.9765 49.0184H13.0254C10.2244 49.0184 7.95438 46.7482 7.95438 43.9473V19.0554H15.8028C18.1357 19.0554 20.0282 17.1636 20.0282 14.8301V6.98163H35.9765C38.7768 6.98163 41.0469 9.25169 41.0469 12.0527V43.9473Z"
        fill="#2962FF"
      />
      <path
        d="M34.8904 12.7347H26.5117V21.1135H34.8904V12.7347Z"
        fill="#2962FF"
      />
      <path
        d="M34.8905 25.8055H14.1113V28.1515H34.8905V25.8055Z"
        fill="#2962FF"
      />
      <path
        d="M34.8905 32.5084H14.1113V34.8544H34.8905V32.5084Z"
        fill="#2962FF"
      />
      <path
        d="M34.8905 39.2114H14.1113V41.5574H34.8905V39.2114Z"
        fill="#2962FF"
      />
      <path
        d="M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
        fill="#2962FF"
      />
      <path
        d="M16.5303 8.96967C16.8232 9.26256 16.8232 9.73744 16.5303 10.0303L11.5303 15.0303C11.2374 15.3232 10.7626 15.3232 10.4697 15.0303L8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697C8.76256 11.6768 9.23744 11.6768 9.53033 11.9697L11 13.4393L13.2348 11.2045L15.4697 8.96967C15.7626 8.67678 16.2374 8.67678 16.5303 8.96967Z"
        fill="white"
      />
    </svg>
  )
}
